import script from "./MyButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyButton.vue?vue&type=script&setup=true&lang=ts"

import "./MyButton.vue?vue&type=style&index=0&id=90b7150a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90b7150a"]])

export default __exports__